import styled from "styled-components";
import {
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_SECONDARY
} from "@streeteasy/design-system/colors";
import componentSizes from "@streeteasy/design-system/constants/componentSizes";
import ButtonLink from "@streeteasy/design-system/deprecated/actions/button-link";
import buttonThemes from "@streeteasy/design-system/deprecated/actions/button-link/buttonThemes";
import { Body, SecondarySmall } from "@streeteasy/design-system/typography";

import { smallScreen, xSmallScreen } from "src/shared/constants/screenSizes";

import Section from "../Section";

export const ByOwnerContainer = styled.div`
  border-bottom: 1px solid ${GRAY_LIGHT};
  margin: 56px auto 32px;
  max-width: 465px;
  padding-bottom: 32px;
  width: 100%;
`;

export const ByOwnerButton = styled(ButtonLink).attrs({
  size: componentSizes.SM,
  theme: buttonThemes.SECONDARY
})`
  &:not(:last-child) {
    margin-right: 16px;
  }

  @media screen and (max-width: ${xSmallScreen}px) {
    &:not(:last-child) {
      margin: 0 0 16px;
    }
  }
`;

export const ByOwnerButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;

  @media screen and (max-width: ${xSmallScreen}px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const ByOwnerCopy = styled(SecondarySmall).attrs({ as: "p" })``;

export const RentBuySellCardsContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: column;
  }
`;

export const RentBuySellSectionContainer = styled(Section)`
  background-color: ${GRAY_LIGHTEST};
  padding-top: 64px;
`;

export const ZillowLogo = styled.img.attrs({
  alt: "",
  "aria-hidden": true,
  width: 149
})`
  display: block;
  margin: 0 auto 16px;
`;

export const ZillowLogoText = styled(Body)`
  color: ${TEXT_SECONDARY};
`;
